module.exports = __webpack_public_path__ + "static/media/tecmilenio@2x.237c984c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/tecmilenio@2x.png
// module id = 76
// module chunks = 0